<template>
  <div>
      <b-breadcrumb :class="!isSideBarCollapsed ? 'margin-left-250' : 'margin-left-50'" style="margin-bottom:0rem;padding-bottom:0rem">
        <b-breadcrumb-item active>
          <i  v-if="$route.meta.icon" :class='$route.meta.icon + " fa-lg"'/>
          <h5 style="display:inline;color:black;margin-left:0.5rem"> {{ $t($route.name) }} </h5>
        </b-breadcrumb-item>
      </b-breadcrumb>

      <sidebar-menu v-if="sideBarReady" v-click-outside="clickOutsideSideBar" style="z-index:101 !important;"
          ref="sidebarmenu" :menu="menu" theme="white-theme" :showOneChild="true" width="250px" widthCollapsed="38px" :collapsed="true" :hideToggle="isCollapseLocked">
      <div slot="footer" v-if="!isSideBarCollapsed">
        <b-row align-h="center" style="height:35px">
        <i @click.stop="lockSidebarCollapse" class="fa fa-2x" :class="isCollapseLocked ? 'fa-lock' : 'fa-lock-open' " />
        </b-row>
      </div>
      </sidebar-menu>
        <dashboard-content :class="!isSideBarCollapsed ? 'margin-left-200' : ''" > </dashboard-content>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
  </div>
</template>

<style>
.margin-left-50 {
  margin-left:50px;
}
.margin-left-250 {
  margin-left:250px;
}
.margin-left-200 {
  margin-left:200px;
}

.v-sidebar-menu.vsm_white-theme {
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}

.v-sidebar-menu.vsm_white-theme .vsm--link {
  padding: 4px;
  font-size: 14px;
}
.v-sidebar-menu.vsm_white-theme.vsm_collapsed .vsm--link_level-1.vsm--link_hover .vsm--icon,
.v-sidebar-menu.vsm_white-theme.vsm_collapsed .vsm--link_level-1:hover .vsm--icon,
.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_active .vsm--icon,
.v-sidebar-menu.vsm_white-theme.vsm_expanded .vsm--item_open .vsm--link_level-1 .vsm--icon {
  background-color: #6cc5c4 !important;
  color:white;
}
.v-sidebar-menu.vsm_white-theme.vsm_collapsed .vsm--link_level-1.vsm--link_hover,
.v-sidebar-menu.vsm_white-theme .vsm--item.vsm--item_open {
  background-color: #c8c8c8 !important;
  color:black;
}
.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_exact-active, .v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_active {
  background-color: #c8c8c8;
  box-shadow:2px 0px 0px 0px black inset;
}
.v-sidebar-menu.vsm_white-theme.vsm_expanded .vsm--item_open .vsm--link_level-1 {
  background-color: #c8c8c8;
  color: #87909A;
  font-weight: bold;
  box-shadow:2px 0px 0px 0px #17a2b8 inset;

}
.v-sidebar-menu.vsm_white-theme a:not(.md-button):hover {
  text-decoration: none;
}

.v-sidebar-menu.vsm_white-theme .vsm--dropdown .vsm--list .vsm--item .vsm--link.vsm--link_active  {
  color: black;
  font-weight: bold;
  background-color: #c8c8c8;
}
.v-sidebar-menu.vsm_white-theme .vsm--link:hover,
.v-sidebar-menu.vsm_white-theme .vsm--mobile-item>.vsm--item>.vsm--link {
  color: black;
  background-color: #c8c8c8 !important;
  font-weight: bold;
}

</style>

<script>
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'

export default {
  components: {
    DashboardContent,
    ContentFooter
  },
  data () {
    return {
      sideBarReady: true,
      isCollapseLocked: false,
      isSideBarCollapsed: true,
      menu: [
        {
          header: true,
          title: process.env.VERSION,
          hiddenOnCollapse: true
        },
        {
          title: this.$i18n.t('Main'),
          icon: 'fa fa-user',
          child: [
            {
              title: this.$i18n.t('Customers'),
              href: '/users'
            },
            {
              title: this.$i18n.t('System users'),
              href: '/systemusers'
            },
            {
              title: this.$i18n.t('Accounts'),
              href: '/accounts'
            },
            {
              title: this.$i18n.t('Accounts groups'),
              href: '/accountsGroups'
            },
            {
              title: this.$i18n.t('Card pools'),
              href: '/cardpools'
            },
            {
              title: this.$i18n.t('Groups'),
              href: '/groups'
            },
            {
              title: this.$i18n.t('System groups'),
              href: '/systemGroups'
            },
            {
              title: this.$i18n.t('Support'),
              href: '/support'
            },
            {
              title: this.$i18n.t('General information'),
              href: '/dashboard'
            },
            {
              title: this.$i18n.t('Archived users'),
              href: '/deletedusers'
            }
          ]
        },
        {
          title: this.$i18n.t('Reference book'),
          icon: 'fa fa-book',
          child: [
            {
              title: this.$i18n.t('Payments methods'),
              href: '/paymentsMethods'
            },
            {
              title: this.$i18n.t('Сurrency'),
              href: '/currency'
            },
            {
              title: this.$i18n.t('IP zone'),
              href: '/ipZone'
            },
            {
              title: this.$i18n.t('Buildings'),
              href: '/buildings'
            },
            {
              title: this.$i18n.t('Streets'),
              href: '/streets'
            },
            {
              title: this.$i18n.t('Banks'),
              href: '/banks'
            },
            {
              title: this.$i18n.t('Companies'),
              href: '/companies'
            }
          ]
        },
        {
          title: this.$i18n.t('Reports'),
          icon: 'fa fa-chart-bar',
          child: [
            {
              title: this.$i18n.t('Payments'),
              href: '/ReportsPayments/ReportsPaymentsPayments'
            },
            {
              title: this.$i18n.t('Services'),
              href: '/ReportsServices/ReportsServicesGeneral'
            },
            {
              title: this.$i18n.t('OtherReport'),
              href: '/ReportsOther/ReportsOtherBlocking'
            }
          ]
        },
        {
          title: this.$i18n.t('Tariffication'),
          icon: 'fa fa-coins',
          child: [
            {
              title: this.$i18n.t('Services'),
              href: '/tarrification/Services'
            },
            {
              title: this.$i18n.t('Services templates'),
              href: '/tarrification/ServicesTemplates'
            },
            {
              title: this.$i18n.t('Services in tariffs'),
              href: '/tarrification/ServicesInTariffs'
            },
            {
              title: this.$i18n.t('Tariffs'),
              href: '/tarrification/Tariffs'
            },
            {
              title: this.$i18n.t('Accounting periods'),
              href: '/tarrification/AccountingPeriods'
            },
            {
              title: this.$i18n.t('Charge policies'),
              href: '/tarrification/ChargePolicies'
            },
            {
              title: this.$i18n.t('Coefficient scheme'),
              href: '/tarrification/CoefficientScheme'
            },
            {
              title: this.$i18n.t('Contract type'),
              href: '/tarrification/ContractType'
            },
            {
              title: this.$i18n.t('Time ranges'),
              href: '/tarrification/TimeRanges'
            }
          ]
        },
        {
          header: true,
          title: this.$i18n.t('Settings'),
          hiddenOnCollapse: true
        },
        {
          title: this.$i18n.t('Inventory'),
          icon: 'fa fa-warehouse',
          child: [
            {
              href: '/inventoryProfiles',
              title: this.$i18n.t('Profiles')
            },
            {
              title: this.$i18n.t('Switches'),
              href: '/inventorySwitches'
            },
            {
              title: this.$i18n.t('NetFlow providers'),
              href: '/inventory/netFlowproviders'
            },
            {
              title: this.$i18n.t('Traffic collectors'),
              href: '/inventory/trafficCollectors'
            },
            {
              title: this.$i18n.t('Firewalls'),
              href: '/inventory/firewalls'
            },
            {
              title: this.$i18n.t('Firewall rules'),
              href: '/inventory/firewallRules'
            },
            {
              title: this.$i18n.t('NAS list'),
              href: '/inventory/NASlist'
            },
            {
              title: this.$i18n.t('RabbitMQ servers'),
              href: '/inventory/RabbitMQ'
            },
            {
              title: this.$i18n.t('HTTP servers'),
              href: '/inventory/HTTPServers'
            }
          ]
        },
        {
          title: this.$i18n.t('Systems'),
          icon: 'fa fa-cogs',
          child: [
            {
              title: this.$i18n.t('Main'),
              href: '/system/SettingsSystem'
            },
            {
              title: this.$i18n.t('AdditionalSet'),
              href: '/system/additional'
            },
            {
              title: this.$i18n.t('Archive DB'),
              href: '/system/archiveDB'
            },
            {
              title: this.$i18n.t('RADIUS accounts'),
              href: '/system/radiusAccounts'
            },
            {
              title: this.$i18n.t('Dynamic shaping'),
              href: '/system/dynamicShaping'
            }
          ]
        },
        {
          title: this.$i18n.t('Customer portal'),
          icon: 'fa fa-user-cog',
          child: [
            {
              title: this.$i18n.t('Switch tariff'),
              href: '/CustomerPortal/SettingsSwitchTariff'
            },
            {
              title: this.$i18n.t('Payment systems'),
              href: '/CustomerPortal/SettingsPaymentSystems'
            },
            {
              title: this.$i18n.t('Promised payments'),
              href: '/CustomerPortal/SettingsPromisedPayments'
            },
            {
              title: this.$i18n.t('Internal transfer'),
              href: '/CustomerPortal/SettingsTransferFunds'
            },
            {
              title: this.$i18n.t('Voluntary suspension'),
              href: '/CustomerPortal/SettingsVoluntarySuspension'
            },
            {
              title: this.$i18n.t('Services and tariffs connect'),
              href: '/CustomerPortal/SettingsCustomerIndependentServiceConnect'
            },
            {
              title: this.$i18n.t('Captive portal'),
              href: '/CustomerPortal/SettingsCaptivePortal'
            },
            {
              title: this.$i18n.t('Tech support chat'),
              href: '/CustomerPortal/SettingsCustomerTSChat'
            },
            {
              title: this.$i18n.t('Edit profile'),
              href: '/CustomerPortal/SettingsEditProfile'
            },
            {
              title: this.$i18n.t('Customer reports'),
              href: '/CustomerPortal/SettingsAvailReports'
            },
            {
              title: this.$i18n.t('Customer docs'),
              href: '/CustomerPortal/SettingsAvailDocs'
            },
            {
              title: this.$i18n.t('Activating card'),
              href: '/CustomerPortal/SettingsActivatingCard'
            },
            {
              title: this.$i18n.t('24TV'),
              href: '/CustomerPortal/Settings24TV'
            },
            {
              title: this.$i18n.t('Rentsoft'),
              href: '/CustomerPortal/SettingsCustomerRentsoft'
            },
            {
              title: this.$i18n.t('Socially significant resources'),
              href: '/CustomerPortal/SettingsSSRService'
            }
          ]},
        {
          icon: 'fa fa-file-alt',
          title: this.$i18n.t('Documents'),
          child: [
            {
              title: this.$i18n.t('Document templates'),
              href: '/documents/documentTemplates'
            },
            {
              title: this.$i18n.t('Profiles of documents'),
              href: '/documents/profilesOfDocuments'
            },
            {
              title: this.$i18n.t('Replacements in document'),
              href: '/documents/replacementsInDocument'
            }
          ]
        },
        {
          title: this.$i18n.t('Network'),
          icon: 'fa fa-network-wired',
          child: [
            {
              title: this.$i18n.t('ISG attributes'),
              href: '/network/ISGattributes'
            },
            {
              title: this.$i18n.t('Tunnel Radius Attributes'),
              href: '/network/TunnelRadiusAttribute'
            },
            {
              title: this.$i18n.t('ISG profile'),
              href: '/network/ISGprofile'
            },
            {
              title: this.$i18n.t('Traffic classes'),
              href: '/network/TrafficClasses'
            },
            {
              title: this.$i18n.t('IP pools'),
              href: '/network/ipPools'
            },
            {
              title: this.$i18n.t('IP groups'),
              href: '/network/ipgroups'
            },
            {
              title: this.$i18n.t('DHCPv4 pools'),
              href: '/network/DhcpPools'
            },
            {
              title: this.$i18n.t('DHCPv4 leases'),
              href: '/network/DhcpLeases'
            },
            {
              title: 'DHCPv6',
              href: '/network/DHCPv6'
            }
          ]
        },
        {
          title: this.$i18n.t('TelephonyReports'),
          icon: 'fa fa-phone-square-alt',
          child: [
            {
              title: this.$i18n.t('Emergency calls'),
              href: '/telephony/emergencyCalls'
            },
            {
              title: this.$i18n.t('Telephone operators'),
              href: '/telephony/telephoneOperators'
            },
            {
              title: this.$i18n.t('Zones'),
              href: '/telephony/TelephoneTarifficationZones'
            },
            {
              title: this.$i18n.t('Directions'),
              href: '/telephony/TelephoneTarifficationDirections'
            },
            {
              title: this.$i18n.t('Telephone numbers'),
              href: '/telephony/telephonenum'
            }
          ]
        }

      ],
      navbarData: {
        elementId: 'main-navbar',
        isUsingVueRouter: true,
        mobileBreakpoint: 992,
        brandImagePath: '/dashboard',
        brandImage: require('@/assets/img/favicon.png'),
        brandImageAltText: 'vue-navigation-bar',
        collapseButtonStyle: 'dark',
        ariaLabelMainNav: 'Main Navigation',
        menuOptionsLeft: [

        ],
        menuOptionsRight: [
          {
            type: 'button',
            text: this.$i18n.t('Logout'),
            path: '/logout',
            class: 'button-red'
          }
        ]
      },
      collapseImage: require('@/assets/img/arrow_state_grey_right.png'),
      is_dev: process.env.NODE_ENV === 'development'
    }
  },
  methods: {
    logout: function () {
      this.$cookie.delete('session_id')
      this.$router.push('login')
    },
    clickOutsideSideBar: function () {
      if (!this.isCollapseLocked) {
        this.$refs.sidebarmenu.isCollapsed = true
      }
    },
    lockSidebarCollapse () {
      this.isCollapseLocked = !this.isCollapseLocked
      localStorage.isCollapseLocked = this.isCollapseLocked
    }
  },
  computed: {
    webSettings () {
      return this.$store.getters['Users/WEB_SETTINGS']
    }
  },
  watch: {
    webSettings: function (val) {
      this.sideBarReady = false
      if (Object.prototype.toString.call(val) === '[object Array]') {
        for (let elGroups of val) {
          for (let elGroup of elGroups) {
            let localedName = this.$t(elGroup.name)
            for (let iMenu = 0; iMenu < this.menu.length; iMenu++) {
              if (this.menu[iMenu].title === localedName) {
                for (let elGroupItems of elGroup.items) {
                  let localedTabName = this.$t(elGroupItems.name)
                  for (let iMenuItem = 0; iMenuItem < this.menu[iMenu].child.length; iMenuItem++) {
                    if (this.menu[iMenu].child[iMenuItem].title === localedTabName) {
                      if (!elGroupItems.is_allowed) {
                        this.menu[iMenu].child.splice(iMenuItem, 1)
                      }
                      break
                    }
                  }
                }
                break
              }
            }
          }
        }
        this.menu = this.menu.filter(elMenu => {
          if (!elMenu.child) {
            return true
          }
          return elMenu.child.length > 0
        })
      } else {
        if (val.name) {
          if (!val.is_allowed) {
            this.menu = []
          }
        }
      }
      this.sideBarReady = true
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_WEB_SETTINGS')
    if (localStorage.isSideBarCollapsed) {
      this.isSideBarCollapsed = localStorage.isSideBarCollapsed === 'true'
      if (!this.isSideBarCollapsed) {
        this.$refs.sidebarmenu.isCollapsed = false
      }
    }
    if (localStorage.isCollapseLocked) {
      this.isCollapseLocked = localStorage.isCollapseLocked === 'true'
    }

    this.$watch(
      () => {
        return this.$refs.sidebarmenu.isCollapsed
      },
      (val) => {
        localStorage.isSideBarCollapsed = val
        this.isSideBarCollapsed = val
      }
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/layout/DashboardLayout.vue